// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const breloom: PokeData = {
  "id": 286,
  "name": "breloom",
  "height": 12,
  "weight": 392,
  "base_experience": 161,
  "types": [
    PokeType.GRASS,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "counter",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "toxic",
    "spore",
    "mind-reader",
    "mach-punch",
    "giga-drain",
    "dynamic-punch",
    "focus-punch",
    "brick-break",
    "sky-uppercut",
    "feint",
    "worry-seed",
    "force-palm",
    "seed-bomb",
    "drain-punch"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "poison-powder",
    "stun-spore",
    "drain-punch",
    "vacuum-wave",
    "wood-hammer",
    "flower-rush",
    "karate-chop",
    "bullet-seed",
    "rolling-kick",
    "coaching",
    "bulk-up"
  ],
  "evolution_chain": {
    "id": 142,
    "item": null,
    "species": [
      {
        "name": "shroomish",
        "order": 311,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "breloom",
        "order": 312,
        "types": [
          PokeType.GRASS,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 285,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 23,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 106,
    "ability_power": 196
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
